import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import LargeContentToggle from 'components/Common/LargeContentToggle'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import MarkdownRender from 'LuxKit/MarkdownRender'
import BodyText from 'LuxKit/Typography/BodyText'
import { EmptyArray } from 'lib/array/arrayUtils'
import { useIntl } from 'react-intl'

interface Props {
  inclusions?: Array<App.OfferInclusion>
  maxHeight: number
  collapsedHeight?: number
  content?: string
  showMoreText?: string
  showLessText?: string
  heading?: string
}

function AccommodationOfferInclusionsExpandable({
  maxHeight,
  collapsedHeight,
  showLessText,
  showMoreText,
  inclusions = EmptyArray,
  content,
  heading,
}: Props) {
  const intl = useIntl()

  const resolvedShowLessText = showLessText ?? intl.formatMessage({
    id: 'FNKxHD3fFrTa43MyF1At',
    defaultMessage: 'View less inclusions',
    description: 'Toggle text to collapse inclusions list on accommodation offer page',
  })
  const resolvedShowMoreText = showMoreText ?? intl.formatMessage({
    id: 'Z2TgaCuIlotsrKRmKce-',
    defaultMessage: 'View more inclusions',
    description: 'Toggle text to expand inclusions list on accommodation offer page',
  })

  return <VerticalSpacer gap={4}>
    {heading && inclusions.length > 0 && <BodyText variant="medium" weight="bold" colour="neutral-two">{heading}</BodyText>}
    <LargeContentToggle
      maxHeight={maxHeight}
      collapsedHeight={collapsedHeight}
      showLessText={resolvedShowLessText}
      showMoreText={resolvedShowMoreText}
    >
      {content && inclusions.length === 0 && <MarkdownRender fontSize="medium" type="compact" content={content} />}
      {inclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} />)}
    </LargeContentToggle>
  </VerticalSpacer>
}

export default AccommodationOfferInclusionsExpandable
